import FilePropertyDto from "../../../dto/FilePropertyDto"
import FileTypeDto from "../../../dto/FileTypeDto"
import TagDto from "../../../dto/TagDto"

export enum ActionType {
    HOME_LOAGING = 'HOME_LOAGING',
    HOME_DATA = 'HOME_DATA',
    HOME_ERROR = 'HOME_ERROR'

}

export interface ActionHome {
    type: ActionType.HOME_DATA,
    types: FileTypeDto[],
    properties: FilePropertyDto[],
    tags: TagDto[],

}

export interface ActionHomeError {
    type: ActionType.HOME_ERROR,
    message: String
}


type Action = ActionHome | ActionHomeError

export default Action